import React, { useState, useEffect } from "react"
import NavBar from "./NavBar";
import Footer from "./Footer";
import "./Menu.css"
import { Button, FormControl, Input, InputLabel, FormHelperText } from '@material-ui/core';
import db from "./firebase";
import firebase from "firebase"
import CloseIcon from '@material-ui/icons/Close';

function Menu() {

	const [foodCart, setFoodCart] = useState([]);
	let [totalPriceOfFood, setTotalPriceOfFood] = useState(0);
	const [orderedFood, setOrderedFood] = useState([]);
	const [payment, setPayment] = useState(false);
	const [placeOrderName, setPlaceOrderName] = useState('');
	const [placeOrderEmail, setPlaceOrderEmail] = useState('');
	const [placeOrderDeliveryAddress, setPlaceOrderDeliveryAddress] = useState('');
	const [placeOrderPhoneNumber, setPlaceOrderPhoneNumber] = useState('');

	const addItemToTheCart = ({foodImg, foodName, foodPrice}) => {
		setFoodCart([...foodCart, {foodImg, foodName, foodPrice}]);
		const priceOfFood = parseInt(foodPrice);
		setOrderedFood([...orderedFood, {foodImg, foodPrice, foodName}]);
		setTotalPriceOfFood(totalPriceOfFood += priceOfFood);
	}

	const showPayment = () => {
		const paymentWindow = document.querySelector(".home__foodCartCheckoutfinal");
		paymentWindow.classList.toggle("home__activeFoodCartCheckoutfinal");
		setPayment(!payment)
	} 

	const showOrderPlacedMsg = () => {
		const homePagePlacedOrderMessageContainer = document.querySelector(".home__homePagePlacedOrderMessageContainer");

		homePagePlacedOrderMessageContainer.classList.toggle("home__activeHomePagePlacedOrderMessageContainer");
	}

	const activeFoodCart = () => {
		const homeFoodCart = document.querySelector(".home__foodCart");

		homeFoodCart.classList.toggle("home__activeFoodCart")
	}


	const placeOrder = () => {
		db.collection("orders").add({
			orderName: placeOrderName,
			orderEmail: placeOrderEmail,
			orderDeliveryAddress: placeOrderDeliveryAddress,
			orderFood: orderedFood,
			orderPrice: totalPriceOfFood,
			orderPhoneNumber: placeOrderPhoneNumber,
			timestamp: firebase.firestore.FieldValue.serverTimestamp()
		}).then(() => {
			showOrderPlacedMsg();
			setTotalPriceOfFood(0);
			setFoodCart([]);
			setPlaceOrderName('');
			setPlaceOrderEmail('');
			setPlaceOrderDeliveryAddress('');
			setPlaceOrderPhoneNumber('');
			setOrderedFood([]);
		})
	}

	const [mainDishes, setMainDishes] = useState([]);
	const [salads, setSalads] = useState([]);
	const [iceCream, setIceCream] = useState([]);
	const [drinks, setDrinks] = useState([]);
	const [desserts, setDesserts] = useState([]);
	const [friedRice, setFriedRice] = useState([]);
	const [noodles, setNoodles] = useState([]);


	useEffect(() => {
		db.collection("mainFoods").onSnapshot(snapshot => {
			setMainDishes(snapshot.docs.map(doc => doc.data()))
		})
		db.collection("salads").onSnapshot(snapshot => {
			setSalads(snapshot.docs.map(doc => doc.data()))
		})
		db.collection("iceCream").onSnapshot(snapshot => {
			setIceCream(snapshot.docs.map(doc => doc.data()))
		})
		db.collection("drinks").onSnapshot(snapshot => {
			setDrinks(snapshot.docs.map(doc => doc.data()))
		})
		db.collection("Dessert").onSnapshot(snapshot => {
			setDesserts(snapshot.docs.map(doc => doc.data()))
		})
		db.collection("noodles").onSnapshot(snapshot => {
			setNoodles(snapshot.docs.map(doc => doc.data()))
		})
		db.collection("friedRice").onSnapshot(snapshot => {
			setFriedRice(snapshot.docs.map(doc => doc.data()))
		})
	}, [])

	console.log(mainDishes)

	return (
		<div className="menu">
			<NavBar page="menu"/>

			<div className="home__foodCart">
					<div className="home__foodCartAddedFoods">
						{
							foodCart.map(food => {
								return (
									<div className="home__foodCartAddedFood">
										<img src={food.foodImg} className="home__foodCartAddedFoodImg"/>
										<div className="home__foodCartAddedFoodNameContainer">
											<div className="home__foodCartAddedFoodName"> {food.foodName} </div>
											<div className="home__foodCartAddedFoodPrice"> ${food.foodPrice} </div>
										</div>
									</div>
								)
							})
						}

					</div>

					<div className="home__homePagePlacedOrderMessageContainer">
						<div className="home__homePagePlacedOrderMessage">
							<div className="orderPlacedTxt"> Order Placed </div>
							<Button variant="contained" color="primary" onClick={showOrderPlacedMsg}> Okay </Button>
						</div>
					</div>

					<div className="home__foodCartCheckoutfinal">
						<div className="home__paymentTotalPriceTxt"> Total price </div>
						<div className="home__paymentTotalPrice"> ${totalPriceOfFood + 5} </div>
						<CloseIcon className="home__foodCartCheckoutCloseIcon" onClick={showPayment}/>
						<FormControl className="home__paymentInputs">
							<InputLabel htmlFor="my-input">User Name</InputLabel>
							<Input type="text" value={placeOrderName} onChange={event => setPlaceOrderName(event.target.value)} id="my-input" aria-describedby="my-helper-text" />
						</FormControl>
						<FormControl className="home__paymentInputs">
							<InputLabel htmlFor="my-input">Email Address</InputLabel>
							<Input type="email" value={placeOrderEmail} onChange={event => setPlaceOrderEmail(event.target.value)} id="my-input" aria-describedby="my-helper-text" />
						</FormControl>
						<FormControl className="home__paymentInputs">
							<InputLabel htmlFor="my-input">Delivery Address</InputLabel>
							<Input type="text" value={placeOrderDeliveryAddress} onChange={event => setPlaceOrderDeliveryAddress(event.target.value)} id="my-input" aria-describedby="my-helper-text" />
						</FormControl>
						<FormControl className="home__paymentInputs">
							<InputLabel htmlFor="my-input">Phone Number</InputLabel>
							<Input type="text" value={placeOrderPhoneNumber} onChange={event => setPlaceOrderPhoneNumber(event.target.value)} id="my-input" aria-describedby="my-helper-text" />
						</FormControl>
						<Button variant="contained" color="primary" onClick={placeOrder}> Place Order </Button>
					</div>

					<div className="home__foodCartCheckout">
						<div className="home__foodCartItemPrices">
							<div className="home__foodCartCheckoutChildren"> <div> Total price </div> : <div> ${totalPriceOfFood} </div> </div>
							<div className="home__foodCartCheckoutChildren"> <div> Shpping Fee </div> : <div> $5 </div> </div>
							<div className="home__foodCartCheckoutChildren"> <div> Total Price </div> : <div> ${totalPriceOfFood + 5} </div> </div>
						</div>
						<Button variant="contained" color="secondary" onClick={showPayment}> Checkout </Button>
					</div>
					<CloseIcon className="home__foodCartCloseIcon" onClick={activeFoodCart}/>
				</div>			

				<div className="menu__paperMenu">
					<div className="menu__paperMenuImg">

					</div>
				</div>

				<div className="menu__foodMenu">
					<h1 className="menu__foodCategory"> Main Dishes </h1>
					<div className="home__homePageFood">
					{
						friedRice.map(food => {
							return (
								<div className="home__homePageMainFood">
									<div className="home__homePageMainFoodImgContainer">
										<img src={food.foodImg}  className="home__homePageMainFoodImg"/>
										<div className="home__homePageFoodPrice"> ${food.foodPrice}</div>
									</div>
									<div className="home__homePageMainFoodName"> {food.foodName} </div>
									<div className="home__homePageMainFoodSmallDesc"> {food.shortDescAbtFood} </div>
									<div className="home__homePageMainFoodButtons">
										<Button variant="contained" color="primary"> Order now </Button>
										<Button
										variant="contained"
										color="secondary"
										onClick={() => addItemToTheCart({foodImg: food.foodImg, foodName: food.foodName, foodPrice: food.foodPrice})}>
										 Add to cart
										</Button>
									</div>
								</div>
							)
						})
					}
					{
						noodles.map(food => {
							return (
								<div className="home__homePageMainFood">
									<div className="home__homePageMainFoodImgContainer">
										<img src={food.foodImg}  className="home__homePageMainFoodImg"/>
										<div className="home__homePageFoodPrice"> ${food.foodPrice}</div>
									</div>
									<div className="home__homePageMainFoodName"> {food.foodName} </div>
									<div className="home__homePageMainFoodSmallDesc"> {food.shortDescAbtFood} </div>
									<div className="home__homePageMainFoodButtons">
										<Button variant="contained" color="primary"> Order now </Button>
										<Button
										variant="contained"
										color="secondary"
										onClick={() => addItemToTheCart({foodImg: food.foodImg, foodName: food.foodName, foodPrice: food.foodPrice})}>
										 Add to cart
										</Button>
									</div>
								</div>
							)
						})
					}
					</div>

					<h1 className="menu__foodCategory"> Salad </h1>
					<div className="home__homePageFood">
						{
						salads.map(food => {
							return (
								<div className="home__homePageMainFood">
									<div className="home__homePageMainFoodImgContainer">
										<img src={food.foodImg}  className="home__homePageMainFoodImg"/>
										<div className="home__homePageFoodPrice"> ${food.foodPrice}</div>
									</div>
									<div className="home__homePageMainFoodName"> {food.foodName} </div>
									<div className="home__homePageMainFoodSmallDesc"> {food.shortDescAbtFood} </div>
									<div className="home__homePageMainFoodButtons">
										<Button variant="contained" color="primary"> Order now </Button>
										<Button
										variant="contained"
										color="secondary"
										onClick={() => addItemToTheCart({foodImg: food.foodImg, foodName: food.foodName, foodPrice: food.foodPrice})}>
										 Add to cart
										</Button>
									</div>
								</div>
							)
						})
					}
					</div>
					<h1 className="menu__foodCategory"> Ice Cream </h1>
					<div className="home__homePageFood">
						{
						iceCream.map(food => {
							return (
								<div className="home__homePageMainFood">
									<div className="home__homePageMainFoodImgContainer">
										<img src={food.foodImg}  className="home__homePageMainFoodImg"/>
										<div className="home__homePageFoodPrice"> ${food.foodPrice}</div>
									</div>
									<div className="home__homePageMainFoodName"> {food.foodName} </div>
									<div className="home__homePageMainFoodSmallDesc"> {food.shortDescAbtFood} </div>
									<div className="home__homePageMainFoodButtons">
										<Button variant="contained" color="primary"> Order now </Button>
										<Button
										variant="contained"
										color="secondary"
										onClick={() => addItemToTheCart({foodImg: food.foodImg, foodName: food.foodName, foodPrice: food.foodPrice})}>
										 Add to cart
										</Button>
									</div>
								</div>
							)
						})
					}
					</div>
					<h1 className="menu__foodCategory"> Drinks </h1>
					<div className="home__homePageFood">
						{
						drinks.map(food => {
							return (
								<div className="home__homePageMainFood">
									<div className="home__homePageMainFoodImgContainer">
										<img src={food.foodImg}  className="home__homePageMainFoodImg"/>
										<div className="home__homePageFoodPrice"> ${food.foodPrice}</div>
									</div>
									<div className="home__homePageMainFoodName"> {food.foodName} </div>
									<div className="home__homePageMainFoodSmallDesc"> {food.shortDescAbtFood} </div>
									<div className="home__homePageMainFoodButtons">
										<Button variant="contained" color="primary"> Order now </Button>
										<Button
										variant="contained"
										color="secondary"
										onClick={() => addItemToTheCart({foodImg: food.foodImg, foodName: food.foodName, foodPrice: food.foodPrice})}>
										 Add to cart
										</Button>
									</div>
								</div>
							)
						})
					}
					</div>
					<h1 className="menu__foodCategory"> Dessert </h1>
					<div className="home__homePageFood">
						{
						desserts.map(food => {
							return (
								<div className="home__homePageMainFood">
									<div className="home__homePageMainFoodImgContainer">
										<img src={food.foodImg}  className="home__homePageMainFoodImg"/>
										<div className="home__homePageFoodPrice"> ${food.foodPrice}</div>
									</div>
									<div className="home__homePageMainFoodName"> {food.foodName} </div>
									<div className="home__homePageMainFoodSmallDesc"> {food.shortDescAbtFood} </div>
									<div className="home__homePageMainFoodButtons">
										<Button variant="contained" color="primary"> Order now </Button>
										<Button
										variant="contained"
										color="secondary"
										onClick={() => addItemToTheCart({foodImg: food.foodImg, foodName: food.foodName, foodPrice: food.foodPrice})}>
										 Add to cart
										</Button>
									</div>
								</div>
							)
						})
					}
					</div>
				</div>

			<Footer />
		</div>
	)
}

export default Menu;